/* @flow */

import React from 'react';
import { connect } from 'react-redux';

import moment from 'moment';

import * as reactGA from 'lib/analytics';
import TagManager from 'react-gtm-module';

import LoadingComponent from 'components/loading';

import OfferTabXmlViewComponent from './view';

import LeadOfferDefaults from 'models/leads/leadOfferDefaults';
import LeadOfferForm from 'models/leads/leadOffer';

import CreateLeadOfferRequest from 'models/requests/leads/createLeadOfferRequest';

import CompanyService from 'services/CompanyService';
import LeadService from 'services/LeadService';
import { getCampaignId } from 'lib/marketing';
import { handleApiFormResponse, handleFormChange, handleFormValidation } from 'lib/forms';
import loadConstraints from 'lib/validation/loadConstraints';

import NotificationHelper from 'lib/notifications';

import { ROLE_ISO } from 'constants/companyRoles';

type OfferTabXmlComponentProps = {
  activeCompanyRole: number;
  activeCompanyId: number;
  enableBackButton: boolean;
  leadId: number;
  successHandler: (leadOfferId: number) => void;
  backHandler: () => void;
  changeToRegularFlow: () => void;
};

type OfferTabXmlComponentState = {
  constraints: any;
  defaults: LeadOfferDefaults;
  errors: Map<string,?string>;
  formErrors: string[];
  isLoading: boolean;
  isProcessing: boolean;
  xmlFile: ?File;
  filename: string;
};

class OfferTabXmlComponent extends React.Component<OfferTabXmlComponentProps, OfferTabXmlComponentState> {

  constructor(props) {
    super(props);

    this.state = {
      constraints: null,
      defaults: null,
      errors: null,
      xmlFile: null,
      formErrors: [],
      isLoading: true,
      isProcessing: false
    };
  }

  componentDidMount = async () => {
    reactGA.initializeGA();
    reactGA.logEvent('Offer', 'Is Eligible', `Lead Id: ${this.props.leadId}`);

    try {
      this.setState({
        isLoading: false
      });
    } catch (e) {
      console.error(e);
      NotificationHelper.createNotification(NotificationHelper.TYPE_ERROR);
    }
  };

  handleDocumentSelect = (file: File) => {
    const xmlFile = file;
    this.setState({ xmlFile, filename: file.filename, formErrors: [], showUploadButton: false, invoiceDraft: null });
  };

  handleDocumentRemove = () => {
    const xmlFile = null;
    this.setState({ xmlFile, filename: null });
  };

  uploadFile = async () => {
    if (this.state.xmlFile === null) return;
    this.setState({ formErrors: [], isProcessing: true });

    try {
      const leadOfferId = await LeadService.createLeadOfferFromXml(this.props.leadId, getCampaignId(), this.props.activeCompanyRole === ROLE_ISO ? this.props.activeCompanyId : 0, this.state.xmlFile);
      TagManager.dataLayer({ dataLayer: { event: 'offerDebtorInfoValidated', formType: 'Offer' } });
      this.props.successHandler(leadOfferId);
    } catch (e) {
      handleApiFormResponse.call(this, e);
      this.setState({ isProcessing: false });
    }
  }

  render() {
    if (this.state.isLoading) {
      return (<LoadingComponent />);
    }

    return (
      <OfferTabXmlViewComponent
        defaults={this.state.defaults}
        errors={this.state.errors}
        form={this.state.form}
        formErrors={this.state.formErrors}
        isProcessing={this.state.isProcessing}
        goBack={this.props.backHandler}
        changeToRegularFlow={this.props.changeToRegularFlow}
        file={this.state.xmlFile}
        handleDocumentSelect={this.handleDocumentSelect}
        handleDocumentRemove={this.handleDocumentRemove}
        uploadFile={this.uploadFile}
      />
    );
  }
}

const mapStateToProps = state => ({
  activeCompanyRole: state.auth.user !== null ? state.auth.user.activeCompany.role : 0,
  activeCompanyId: state.auth.user !== null ? state.auth.user.activeCompany.id : 0
});

export default connect(mapStateToProps)(OfferTabXmlComponent);
